import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AssessmentService } from '../core/services/assessment.service';
import { CommonService } from '../core/services/common.service';
import { StorageService } from '../core/services/storage.service';
import { GlobalConstants } from '../shared/constants/global-constants';

@Component({
  selector: 'app-executor-dashboard',
  templateUrl: './executor-dashboard.component.html',
  styleUrls: ['./executor-dashboard.component.css'],
})
export class ExecutorDashboardComponent implements OnInit {
  isArabic!: boolean;
  tabId: string = 'execution';
  isFirstTime: boolean = false;
  isChecker = this.storageService.getSessionStorageData('isChecker');
  ifAssesment: any;
  ifPendingActionItem: any;
  ifRejectedActionItem: any;
  ifHistoricalActionItem: any;
  ifReviewAssesment: any;
  isResubmitRejectedAssessment: any;
  isResubmitRejectedAssessmentForChecker: any;
  executionList = [
    {
      value: 'User Profile',
      arabicValue: 'الملف الشخصي للمستخدم',
      img: '../../../assets/images/user-profile.svg',

      isActive: false,
      link: 'user-profile',
      isShow: true
    },
    {
      value: 'Initiate Assessment',
      arabicValue: 'بدء التقييم',
      img: '../../../assets/images/initiate-assessment.svg',
      isActive: false,
      link: 'assessment',
      isShow: !this.isChecker
    },
    {
      value: 'Progress Tracker',
      arabicValue: 'متتبع التقدم',
      img: '../../../assets/images/progress-tracker.svg',
      isActive: false,
      link: 'progress-tracker',
      isShow: true
    },
    {
      value: 'Resubmit Response',
      arabicValue: 'إعادة تسليم طلب التقييم',
      img: '../../../assets/images/resubmit-response.svg',
      isActive: false,
      link: 'resubmit-clarify',
      isShow: !this.isChecker
    },
    {
      value: 'Historical Assessments',
      arabicValue: 'التقييمات السابقة',
      img: '../../../assets/images/historical-assessments.svg',
      isActive: false,
      link: 'historical-assesment',
      isShow: true
    },
    // {
    //   value: 'Action Items',
    //   arabicValue: '',
    //   img: '../../../assets/images/reportan-issue.png',
    //   isActive: false,
    //   link: 'action-items',
    //   isShow : true
    // },
    // {
    //   value: 'Request User access',
    //   arabicValue: 'طلب صلاحية مستخدم جديد',
    //   img: '../../../assets/images/request-user-access.svg',
    //   isActive: false,
    //   link: 'request-user-access',
    //   isShow: true
    // },
    {
      value: 'Inquiry',
      arabicValue: 'الإستفسارات',
      img: '../../../assets/images/report-issue.svg',
      isActive: false,
      link: 'report-issue',
      isShow: true
    },
    {
      value: 'Archived Issues',
      arabicValue: 'الإستفسارات المؤرشفة',
      img: '../../../assets/images/archived-issues.svg',
      isActive: false,
      link: 'cases',
      isShow: true
    },
    {
      value: 'Resources',
      arabicValue: 'الموارد',
      img: '../../../assets/images/resources.svg',
      isActive: false,
      link: 'resources',
      isShow: true
    }
    // {
    //   value: 'Risk rating review',
    //   arabicValue: 'مراجعة تقييم المخاطر',
    //   img: '../../../assets/images/risk-rating.png',
    //   isActive: false,
    //   link: 'risk-rating',
    // },
  ];
  monitoringList = [
    {
      value: 'Review and Approval',
      arabicValue: 'المراجعة والموافقة',
      img: '../../../assets/images/review-approval.png',
      isActive: false,
      link: 'monitoring/review',
      isShow: true
    },
    {
      value: 'Resubmit Response (Rejected Responses)',
      arabicValue: 'إعادة إرسال الرد (الردود المرفوضة)',
      img: '../../../assets/images/resumt-question.png',
      isActive: false,
      link: 'monitoring/resubmit',
      isShow: true
    },
  ];
  actionItemsList = [
    {
      value: 'Pending Action Plans',
      arabicValue: 'خطة العمل قيد الانتظار',
      img: '../../../assets/images/pending-action-plans.svg',
      isActive: false,
      link: 'action-items/pending',
      isShow: true
    },
    {
      value: 'Resubmit Action Plans',
      arabicValue: 'خطة العمل المرفوضة',
      img: '../../../assets/images/rejected-action-plans.svg',
      isActive: false,
      link: 'action-items/rejected',
      isShow: true
    },
    {
      value: 'Historical Action Plans',
      arabicValue: 'السجل التاريخي لخطة العمل',
      img: '../../../assets/images/historical-action-plans.svg',
      isActive: false,
      link: 'action-items/historical',
      isShow: true
    },
  ];
     enforcementList = [
    {
      value: 'Active Enforcement',
      arabicValue: 'الإجراءات التنفيذية النشطة',
      img: '../../../assets/images/pending-action-plans.svg',
      isActive: false,
      link: 'enforcement/active',
      isShow: true
    },
    {
      value: 'Historical Enforcement',
      arabicValue: 'التقييمات السابقة',
      img: '../../../assets/images/rejected-action-plans.svg',
      isActive: false,
      link: 'enforcement/historical',
      isShow: true
    }
  ];
   finesList = [
    {
      value: 'Active Fines',
      arabicValue: 'الغرامات المطبقة',
      img: '../../../assets/images/pending-action-plans.svg',
      isActive: false,
      link: 'fines/active',
      isShow: true
    },
    {
      value: 'Historical Fines',
      arabicValue: 'الغرامات السابقة',
      img: '../../../assets/images/rejected-action-plans.svg',
      isActive: false,
      link: 'fines/historical',
      isShow: true
    }
  ];
   appealList = [
    {
      value: 'Initiate Appeal',
      arabicValue: 'تقديم طلب تظلّم',
      img: '../../../assets/images/pending-action-plans.svg',
      isActive: false,
      link: 'appeal/initiate',
      isShow: true
    },
    {
      value: 'Historical Appeal',
      arabicValue: 'التظلّمات السابقة',
      img: '../../../assets/images/rejected-action-plans.svg',
      isActive: false,
      link: 'appeal/historical',
      isShow: true
    }
  ];
  rejectedAssessmentsCount: any = 0;
  userDetails: any;
  isMakerCheckerEnabled: any;
  constructor(private activateRoute: ActivatedRoute,
    private route: Router,
    private storageService: StorageService,
    private assessmentService: AssessmentService,
    private commonService: CommonService,
  ) {
    route.events.subscribe((event: any) => {
      this.isResubmitRejectedAssessment = false;
      this.isResubmitRejectedAssessmentForChecker = false;
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        const currentUrl = event.url;
        // console.log(currentUrl);
        if (currentUrl.includes('reports')) {
          this.tabId = 'reporting';
        }
        else if (currentUrl.includes('action-items')) {
          this.tabId = 'action-items';
          this.actionItemsList.forEach((v, i) => {
            if (currentUrl.includes(v.link)) {
              v.isActive = true;
            } else {
              v.isActive = false;
            }
          });
          this.ifPendingActionItem = currentUrl.includes('action-items/pending') && !currentUrl.includes('action-items/pending/details');
          this.ifRejectedActionItem = currentUrl.includes('action-items/rejected') && !currentUrl.includes('action-items/rejected/details');
          this.ifHistoricalActionItem = currentUrl.includes('action-items/historical') && !currentUrl.includes('action-items/historical/details');
        }
                else if (currentUrl.includes('enforcement')) {
          this.tabId = 'enforcement';
          this.actionItemsList.forEach((v, i) => {
            if (currentUrl.includes(v.link)) {
              v.isActive = true;
            } else {
              v.isActive = false;
            }
          });
        }
        else if (currentUrl.includes('fines')) {
          this.tabId = 'fines';
          this.actionItemsList.forEach((v, i) => {
            if (currentUrl.includes(v.link)) {
              v.isActive = true;
            } else {
              v.isActive = false;
            }
          });
        }
        else if (currentUrl.includes('appeal')) {
          this.tabId = 'appeal';
          this.actionItemsList.forEach((v, i) => {
            if (currentUrl.includes(v.link)) {
              v.isActive = true;
            } else {
              v.isActive = false;
            }
          });
        }
        else if (currentUrl.includes('monitoring')) {
          this.tabId = 'monitoring';
          this.monitoringList.forEach((v, i) => {
            if (currentUrl.includes(v.link)) {
              v.isActive = true;
            } else {
              v.isActive = false;
            }
          });
          this.ifReviewAssesment = currentUrl.includes('monitoring/review');
          this.isResubmitRejectedAssessmentForChecker = currentUrl.includes('monitoring/resubmit');
        } else if (currentUrl.includes('request-user-access;details=') || currentUrl.includes('report-issue;details=')) {
          this.executionList.forEach((v, i) => {
            if (v.value == 'Archived Issues') {
              v.isActive = true;
            } else {
              v.isActive = false;
            }
          });
        } else if (currentUrl.includes('resubmit-clarify')) {
          this.isResubmitRejectedAssessment = true;
        }
        else {
          this.tabId = 'execution';
          this.executionList.forEach((v, i) => {
            if (currentUrl.includes(v.link)) {
              v.isActive = true;
            } else {
              v.isActive = false;
            }
          });
          this.ifAssesment = currentUrl.includes('assessment');
        }
      }
    });
    this.isChecker = this.storageService.getSessionStorageData('isChecker');
    // console.log('this.isChecker: ', this.isChecker);
  }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.isMakerCheckerEnabled = this.storageService.getSessionStorageData('isMakerCheckerEnabled');
    this.calculateRejectedAssessments();
    const hasSeenGreeting = this.storageService.getSessionStorageData('isFirstTime');
    if (!hasSeenGreeting) {
      this.isFirstTime = true;
      this.storageService.setSessionStorageData('isFirstTime', true);
    }
  }

  closePopup() {
    this.isFirstTime = false;
    this.storageService.setSessionStorageData('isFirstTime', true);
  }

  onListItemClick(routeName: string) {
    if (routeName == 'reporting') {
      this.tabId = 'reporting';
      this.route.navigate(['executor-dashboard/reports']);
    }
    else if (routeName == 'action-items') {
      this.tabId = 'action-items';
      this.route.navigate(['executor-dashboard/action-items/pending']);
      // this.route.navigate(['action-items/pending']);
    }    else if (routeName == 'enforcement') {
      this.tabId = 'enforcement';
      this.route.navigate(['executor-dashboard/enforcement/active']);
    }
    else if (routeName == 'fines') {
      this.tabId = 'fines';
      this.route.navigate(['executor-dashboard/fines/active']);
    }
    else if (routeName == 'appeal') {
      this.tabId = 'appeal';
      this.route.navigate(['executor-dashboard/appeal/initiate']);
    }
    else if (routeName == 'monitoring') {
      this.tabId = 'monitoring';
      this.route.navigate(['executor-dashboard/monitoring/review']);
    } else if (routeName == 'execution') {
      this.tabId = 'execution';
      if (this.isChecker) {
        this.route.navigate(['executor-dashboard/progress-tracker']);
      } else {
        this.route.navigate(['executor-dashboard/assessment']);
      }
    }
  }

  calculateRejectedAssessments() {

    // const REJECTED_STATUS = this.isMakerCheckerEnabled ?
    //   GlobalConstants.STATUSES.CHECKER_REJECTED.name :
    //   GlobalConstants.STATUSES.REJECTED.name;

    const REJECTED_STATUS = this.isMakerCheckerEnabled ?
        GlobalConstants.STATUSES.CHECKER_REJECTED.value :
        GlobalConstants.STATUSES.INSPECTOR_REJECTED.value;

    const rqstBody = { assessmentUnit: this.userDetails?.assessmentUnitValue, contactguid: this.userDetails?.contactguid };
    this.assessmentService.fetchSubmittedQuestionnaires(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      //console.log('get submitted questionnaire list in assessment: ', decryptedData);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      let questionnaireList = resp?.questionnaires?.filter((ques: any) => ques.status
        == REJECTED_STATUS && ques.questionnaireMdeValue != null);
      //console.log('list of submitted questionnaires: ', questionnaireList);

      //let selectedQuestionnaire;
      this.rejectedAssessmentsCount = questionnaireList?.length;
    });
  }

}
